<template>
    <div style="pointer-events: all" :data-uuid="settings.uuid">
        <div class="widget-html" v-html="settings.general.html"></div>
        <portal to="editor">
            <CodeEditor collapse-on-hide @input="settings.general.html = $event" :html="settings.general.html" />
        </portal>
    </div>
</template>

<script>
import CodeEditor from "@components/Editor/components/CodeEditor.vue"

export default {
    components: { CodeEditor },
    props: {
        settings: {
            type: Object,
            default: () => {}
        }
    },
    name: "WidgetHtmlBlock"
}
</script>

<style lang="sass" scoped>

</style>
